
import {
  GET_DOCTOR_PROFILE_REQUEST,
  GET_DOCTOR_PROFILE_SUCCESS,
  GET_DOCTOR_PROFILE_FAIL,
} from '../actions/types';

const initialState = {
  loading: false,
  profileData: null,
  error: null,
};

export const doctorProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCTOR_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_DOCTOR_PROFILE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        profileData: action.payload?.data?.[0] || null, 
        error: null 
      };
    case GET_DOCTOR_PROFILE_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default doctorProfileReducer;
